import { Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

const Subtitle = ({ children }: { children: string | ReactNode }) => (
    <Text mb="24px" color="gray.500" fontWeight="500" fontSize="md">
        {children}
    </Text>
);

export default Subtitle;
